// params: addedTagsQuantity, elementType
export const TAG_ELEMENT = 'Tag Element';
// params: elementType
export const MOVE_TO_TAGGED_ELEMENT = 'Move to Tagged Element';
// params: elementType
export const OPEN_TAGGED_ELEMENT_LINK = 'Open Tagged Element Link';
